import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { LangProvider } from "@/contexts/LangContext";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import AnalysisDetail from "@/pages/AnalysisDetail";
import Compare from "@/pages/Compare";
import Trends from "@/pages/Trends";
import TrendDetail from "@/pages/TrendDetail";
import PressKitPublic from "@/pages/PressKitPublic";
import Usage from "@/pages/Usage";
import Docs from "@/pages/Docs";
import Pricing from "@/pages/Pricing";
import Billing from "@/pages/Billing";
import BillingSuccess from "@/pages/BillingSuccess";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center font-mono-tech text-xs uppercase tracking-widest">Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const PublicOnly = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/app" replace />;
  return children;
};

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/docs" element={<Docs />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/billing/success" element={<Protected><BillingSuccess /></Protected>} />
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
            <Route path="/app" element={<Protected><Dashboard /></Protected>} />
            <Route path="/app/analysis/:id" element={<Protected><AnalysisDetail /></Protected>} />
            <Route path="/app/compare" element={<Protected><Compare /></Protected>} />
            <Route path="/app/trends" element={<Protected><Trends /></Protected>} />
            <Route path="/app/trends/:tag" element={<Protected><TrendDetail /></Protected>} />
            <Route path="/app/press-kit" element={<Protected><PressKitPublic /></Protected>} />
            <Route path="/app/usage" element={<Protected><Usage /></Protected>} />
            <Route path="/app/billing" element={<Protected><Billing /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
